import { Grid, MenuItem, Button, Divider, Typography, Switch, Tooltip, makeStyles } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useEffect, useState } from "react";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { Save } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { FetchPatologias } from "../../../actions/recuperos/configuracion/abmPatologias";
import Buscador from "../../../actions/ui/Buscador";
import { useSurge } from "../../../hooks/useCases/useSurge";
import { useFormNew } from "../../../hooks/useFormNew";
import { startAlerta } from "../../../actions/ui/alertas";

const useStyles = makeStyles((theme) => ({
  switchBase: {
    color: '#bdbdbd',
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#4CAF50',
      '& + $track': {
        backgroundColor: '#3E8040',
        opacity: 1,
        border: 'none',
      },
    },
  },
  checked: {},
  track: {},
}));

const fechaActual = new Date();

export const SolicitudForm = ({ solicitudCargada }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [afiliado, setAfiliado] = useState(solicitudCargada ? solicitudCargada.afiliado : null);
  const [disabledAfiliado, setDisabledAfiliado] = useState(false)
  const surge = useSurge()

  const initialState = {
    idAfiliado: solicitudCargada?.idAfiliado || null,
    tutelaje: solicitudCargada?.tutelaje || false,
    colectiva: solicitudCargada?.colectiva || false,
    nroSolicitud: solicitudCargada?.nroSolicitud || "",
    fechaEnvio: solicitudCargada?.fechaEnvio || new Date(),
    periodoDesde: solicitudCargada ? solicitudCargada?.periodoDesde || null : new Date(),
    periodoHasta: solicitudCargada ? solicitudCargada?.periodoHasta || null : new Date(),
    idPatologia: solicitudCargada?.idPatologia || "",
    idConcepto: solicitudCargada?.idConcepto || "",
    idResolucion: solicitudCargada?.idResolucion || "",
    cantidad: solicitudCargada?.cantidad || "",
    montoSolicitado: solicitudCargada?.montoSolicitado || "",
    observaciones: solicitudCargada?.observaciones || ""
  };

  const { formValues, handleInputChange, setearValor, setFormValues, reset } = useFormNew(initialState);

  const onSubmit = (e) => {
    e.preventDefault();
    if (afiliado === null && formValues.colectiva === false) {
      return dispatch(startAlerta("No puede ingresar una solicitud individual sin un afiliado asociado", "error", "Error"))
    }
    if (!solicitudCargada) surge.insert.solicitud(formValues, reset, setAfiliado)
    else surge.update.solicitud(solicitudCargada.id, formValues)
  }

  useEffect(() => {
    dispatch(FetchPatologias());
    surge.getAll.conceptos();
    surge.getAll.matriculas();
    surge.getAll.resoluciones();
    surge.getAll.practicasYDispositivos();
  }, [dispatch]);

  const handlePatologiasChange = (e) => {
    if (surge.data.patologias?.length > 0) {
      const patologia = surge.data.patologias.find(
        (pat) => parseInt(pat?.idPatologia) === parseInt(e.target.value)
      );
      setearValor("idPatologia", patologia.idPatologia);
    }
  }

  const handleChangeSwitchTutelaje = (e) => {
    setearValor("tutelaje", e.target.checked);
  }
  const handleChangeSwitchColectiva = (e) => {
    setAfiliado(null)
    setFormValues({ colectiva: e.target.checked, idAfiliado: null });
    e.target.checked === true ? setDisabledAfiliado(true) : setDisabledAfiliado(false)
  }

  const handleChangeResolucion = (e) => {
    const montoSolicitado = surge.data.practicasYDispositivos.find(rel => rel.concepto === formValues.idConcepto && rel.resolucion === e.target.value)?.valor
    montoSolicitado ? setFormValues({ idResolucion: e.target.value, montoSolicitado: montoSolicitado })
      : setFormValues({ idResolucion: e.target.value, montoSolicitado: "" })

  }

  return (
    <ValidatorForm onSubmit={onSubmit}>
      <Grid container spacing={2}>
        {
          !solicitudCargada &&
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              component="div"
              style={{
                color: 'gray',
                marginLeft: '1rem'
              }}
            >Buscar Afiliado</Typography>
          </Grid>
        }
        <Grid item xs={6}>
          <Buscador
            value={afiliado}
            variant="outlined"
            setValue={(afiliado) => {
              if (afiliado !== null) {
                setAfiliado(afiliado)
                setFormValues({
                  idAfiliado: afiliado?.id_afiliado,
                  periodoDesde: afiliado?.fecha_alta ? afiliado.fecha_alta : new Date(),
                  periodoHasta: afiliado?.fecha_baja ? afiliado.fecha_baja : new Date()
                })
              } else {
                setAfiliado(null)
                setFormValues({
                  idAfiliado: ""
                })
              }
            }}
            label="Apellido y Nombre | Nro Doc | Nro Afiliado | CUIL"
            endpoint={(texto) => `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/Todos/Todos`}
            noOptionText={"No se encuentra afiliado"}
            getOptionLabel={(option) => (`${option.apellido_y_nombre} - ${option.carnet}`)}
            renderOption={(option) => (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ color: option.fecha_baja === null || option.fecha_baja >= fechaActual.toISOString() ? "green" : "red" }}>
                  {`${option.apellido_y_nombre} - DNI: ${option.nro_doc} ${`- CARNET: ${option.carnet}`}`}
                </span>
              </div>
            )}
            fieldsDisabled={disabledAfiliado || solicitudCargada}
          />
        </Grid>
        <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Tooltip title="Si no marca la propiedad la solicitud quedará como individual">
            <Typography>Colectiva</Typography>
          </Tooltip>
          <Switch
            checked={formValues.colectiva}
            value={formValues.colectiva}
            name="colectiva"
            onChange={handleChangeSwitchColectiva}
            classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
            disabled={solicitudCargada}
          >
          </Switch>
        </Grid>
        <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography>Tutelaje</Typography>
          <Switch
            checked={formValues.tutelaje}
            value={formValues.tutelaje}
            name="tutelaje"
            onChange={handleChangeSwitchTutelaje}
            classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}>
          </Switch>
        </Grid>
        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>
        <Grid style={{ marginLeft: '1rem' }} item xs={12}>
          <Typography
            variant="subtitle1"
            component="div"
            style={{
              color: 'gray'
            }}
          >Solicitud</Typography>
        </Grid>
        <Grid item xs={3}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="N° Solicitud"
            autoComplete="off"
            name="nroSolicitud"
            type='number'
            value={formValues.nroSolicitud}
            onChange={(e) => setearValor("nroSolicitud", parseInt(e.target.value))}
            validators={[
              "required"
            ]}
            errorMessages={[
              "Este campo es obligatorio"
            ]}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            disabled={solicitudCargada}
          />
        </Grid>
        <Grid item xs={2}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <KeyboardDatePicker
              fullWidth
              margin="normal"
              label="Fecha de Envío"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              value={
                moment(formValues.fechaEnvio).isValid()
                  ? moment(formValues.fechaEnvio)
                  : null
              }
              onChange={(date) => {
                setearValor("fechaEnvio", date);
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={2}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <KeyboardDatePicker
              fullWidth
              margin="normal"
              label="Período desde"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              maxDate={formValues.periodoHasta}
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              value={
                moment(formValues.periodoDesde).isValid()
                  ? moment(formValues.periodoDesde)
                  : null
              }
              onChange={(date) => {
                setFormValues({
                  periodoDesde: date
                })
              }}
              disabled={solicitudCargada && !solicitudCargada?.periodoHasta}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={2}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <KeyboardDatePicker
              fullWidth
              margin="normal"
              label="Período hasta"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              minDate={formValues.periodoDesde}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              value={
                moment(formValues.periodoHasta).isValid()
                  ? moment(formValues.periodoHasta)
                  : null
              }
              onChange={(date) => {
                setearValor("periodoHasta", date);
              }}
              disabled={solicitudCargada && !solicitudCargada?.periodoDesde}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={3}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Patologia"
            name="idPatologia"
            InputLabelProps={{ style: { fontWeight: "bold" } }}
            validators={["required"]}
            value={formValues.idPatologia}
            onChange={(e) => handlePatologiasChange(e)}
            errorMessages={["Este campo es obligatorio"]}
            style={{ color: "#000" }}
          >
            {surge.data.patologias
              .sort((a, b) => {
                // Función para extraer la parte relevante de la descripción
                const cleanDescription = (descripcion) => {
                  // Si la descripción contiene " - SURGE", se elimina esa parte
                  if (descripcion.includes(" - SURGE")) {
                    return descripcion.split(" - SURGE")[0];
                  }
                  return descripcion;
                };

                const descripcionA = cleanDescription(a.descripcion);
                const descripcionB = cleanDescription(b.descripcion);

                // Si uno de los dos es "OTRAS PATOLOGIAS", ordena según la regla establecida
                if (descripcionA === "OTRAS PATOLOGIAS") return 1;
                if (descripcionB === "OTRAS PATOLOGIAS") return -1;

                // Ordenar alfabéticamente las descripciones limpias
                return descripcionA.localeCompare(descripcionB);
              })
              .map((e) => (
                <MenuItem key={e.idPatologia} value={e.idPatologia}>
                  {e.descripcion}
                </MenuItem>
              ))}
          </SelectValidator>
        </Grid>
        <Grid item xs={2}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Concepto"
            name="idConcepto"
            InputLabelProps={{ style: { fontWeight: "bold" } }}
            validators={["required"]}
            value={formValues.idConcepto}
            onChange={(e) => setFormValues({ idConcepto: e.target.value, idResolucion: "", montoSolicitado: "" })}
            errorMessages={["Este campo es obligatorio"]}
            style={{ color: "#000" }}
          >
            {surge.data.conceptos.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
        <Grid item xs={2}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Resolucion"
            name="idResolucion"
            InputLabelProps={{ style: { fontWeight: "bold" } }}
            validators={["required"]}
            value={formValues.idResolucion}
            onChange={(e) => handleChangeResolucion(e)}
            errorMessages={["Este campo es obligatorio"]}
            style={{ color: "#000" }}
          >
            {surge.data.resoluciones.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
        <Grid item xs={2}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Cantidad"
            autoComplete="off"
            name="cantidad"
            type='number'
            validators={[
              "isNumber",
              "required"
            ]}
            errorMessages={[
              "Solo número entero",
              "Este campo es obligatorio"
            ]}
            value={formValues.cantidad}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Monto solicitado"
            autoComplete="off"
            name="montoSolicitado"
            type='number'
            validators={[
              "required"
            ]}
            errorMessages={[
              "Este campo es obligatorio"
            ]}
            value={formValues.montoSolicitado}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Observaciones"
            multiline
            autoComplete="off"
            name="observaciones"
            value={formValues.observaciones}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
      </Grid>
      <Grid style={{ textAlign: 'center', margin: '1rem' }}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Save />}
          type='submit'
        >
          GUARDAR SOLICITUD
        </Button>
      </Grid>
    </ValidatorForm>
  );
};